import Cookies from 'js-cookie'

// App WebView 注入的用户信息 cookie 名
const USER_INFO_COOKIE = 'UserInfo'

// 延迟初始化，避免 withConverter 异常导致模块加载失败
let rawCookiesInstance

function getRawCookiesInstance() {
  if (rawCookiesInstance === undefined) {
    // prettier-ignore
    try {
      rawCookiesInstance = Cookies.withConverter({ read: (value) => value })
    }
    catch (err) {
      console.log('try catch', err)
      rawCookiesInstance = Cookies
    }
  }
  return rawCookiesInstance
}

// 本次页面加载内 UserInfo 异常只上报一次，避免重复打 log
let userInfoCookieLogReported = false

/**
 * 旧版 UserInfo 解析逻辑（Cookies.get + eval），作为新逻辑失败时的兜底
 * @returns {object|null}
 */
function parseUserInfoCookieLegacy() {
  // prettier-ignore
  try {
    const appInfo = Cookies.get(USER_INFO_COOKIE)
    if (!appInfo) {
      return null
    }
    const obj = eval('(' + appInfo + ')')
    if (!obj || typeof obj !== 'object') {
      return null
    }
    return obj
  }
  catch (err) {
    console.log('try catch', err)
    return null
  }
}

/**
 * 获取 UserInfo cookie 的原始值
 * @returns {string} 原始 cookie 值；不存在时返回空字符串
 */
export function getRawUserInfoCookie() {
  // prettier-ignore
  try {
    const rawValue = getRawCookiesInstance().get(USER_INFO_COOKIE)
    if (rawValue !== undefined) {
      return rawValue
    }

    if (!document.cookie) {
      return ''
    }

    const pairs = document.cookie.split('; ')
    for (let i = 0; i < pairs.length; i++) {
      const pair = pairs[i]
      const eqIndex = pair.indexOf('=')
      if (eqIndex === -1) {
        continue
      }
      if (pair.slice(0, eqIndex) === USER_INFO_COOKIE) {
        return pair.slice(eqIndex + 1)
      }
    }

    return ''
  }
  catch (err) {
    console.log('try catch', err)
    return ''
  }
}

/**
 * 通过客户端注入的 log 通道上报 UserInfo cookie 原始值，便于排查读写异常
 * 仅在 App 内（UA 含 dq）上报，且本次页面加载只上报一次
 * UserInfo cookie 原始字符串
 */
export function reportUserInfoCookieLog(rawValue) {
  // prettier-ignore
  try {
    if (userInfoCookieLogReported || !/dq/i.test(navigator.userAgent)) {
      return
    }

    userInfoCookieLogReported = true
    const payload = JSON.stringify({ content: `UserInfo=${rawValue}` })
    const iosHandler = window.webkit?.messageHandlers?.log
    if (iosHandler?.postMessage) {
      iosHandler.postMessage(payload)
      return
    }
    const androidBridge = globalThis.log
    if (typeof androidBridge?.postMessage === 'function') {
      androidBridge.postMessage(payload)
    }
  }
  catch (err) {
    console.log('try catch', err)
  }
}

/**
 * 读取并解析 App 注入的 UserInfo cookie
 * 1. Cookies.get 取不到有效内容
 * 2. eval 解析失败
 * 3. 解析结果非对象
 * 以上情况会上报原始 cookie 值给客户端，并返回 null
 * 任一步骤异常时回退旧版解析逻辑，避免影响线上行为
 * @returns {object|null} 解析后的用户信息对象；失败时返回 null
 */
export function parseUserInfoCookie() {
  // prettier-ignore
  try {
    const appInfo = Cookies.get(USER_INFO_COOKIE)
    const rawValue = getRawUserInfoCookie()

    if (!appInfo) {
      reportUserInfoCookieLog(rawValue)
      return parseUserInfoCookieLegacy()
    }

    try {
      const obj = eval('(' + appInfo + ')')
      if (!obj || typeof obj !== 'object') {
        reportUserInfoCookieLog(rawValue)
        return parseUserInfoCookieLegacy()
      }
      return obj
    }
    catch (err) {
      reportUserInfoCookieLog(rawValue)
      return parseUserInfoCookieLegacy()
    }
  }
  catch (err) {
    console.log('try catch', err)
    return parseUserInfoCookieLegacy()
  }
}
